import { PickList } from 'primereact/picklist';
import { ProgressSpinner } from 'primereact/progressspinner';

function PickListSelect({ 
    source, 
    target, 
    addToTarget, 
    removeFromTarget, 
    lastElementRef, 
    showTargetSort = false, 
    moveDownInTarget, 
    moveUpInTarget, 
    isInvalid = false, 
    ...props }) {
  const sourceItemTemplate = (item) => {
    return (
      <div 
      ref={item === source && source[source.length - 1] && lastElementRef ? 
        lastElementRef : 
        null} 
      className="d-flex justify-content-between" 
      onClick={() => addToTarget(item)}>
        <div>
          <strong>{item.label}</strong>
          <div>{item.birthDate && <p>DOB: {item.birthDate}</p>}</div>
        </div>
        <i className="pi pi-plus-circle align-self-center" 
        style={{ fontSize: '1.2rem', color: 'slateblue' }} />
      </div>
    );
  };

  const targetItemTemplate = (item) => {
    const index = target && target.indexOf(item);
    const isFirst = index === 0;
    const isLast = target && index === target.length - 1;

    return (
      <div className={showTargetSort ? 'd-flex justify-content-between' : ''}>
        <style>{`
        .selected-item:hover {
          color: rgb(0, 0, 0) !important;
          cursor: pointer;
        }
        .move-buttons:hover {
          color:rgb(255, 184, 79) !important;
          cursor: pointer;
        }
        .selected-item:hover > i {
          color: rgb(255, 68, 68) !important;
        }
      `}</style>

        <div 
        className="d-flex flex-grow-1 justify-content-between selected-item mr-4" 
        onClick={() => removeFromTarget(item)}>
          <div>
            <strong>{item.label}</strong>
            {item.birthDate && <p>DOB: {item.birthDate}</p>}
          </div>
          <i className="pi pi-minus-circle align-self-center" style={{ fontSize: '1.2rem', color: 'slateblue' }}></i>
        </div>

        {showTargetSort && (
          <div className={'d-flex'} style={{ width: '52px', gap: '0.8rem' }}>
            {!isFirst && <i className="pi pi-arrow-up align-self-center move-buttons" style={{ fontSize: '1.2rem', color: 'slateblue' }} onClick={() => moveUpInTarget(item)}></i>}
            {!isLast && <i className="pi pi-arrow-down align-self-center move-buttons" style={{ fontSize: '1.2rem', color: 'slateblue' }} onClick={() => moveDownInTarget(item)}></i>}
          </div>
        )}
      </div>
    );
  };

  const handleSourceFilterChange = (e) => {
    props.onSearch(e.value);
  };

  return (
    <>
      {!source && !target ? (
        <ProgressSpinner />
      ) : (
        <PickList
          className={`p-picklist-custom ${isInvalid ? 'is-invalid' : ''}`}
          source={source}
          target={target}
          sourceHeader="Available"
          targetHeader="Selected"
          sourceItemTemplate={sourceItemTemplate}
          targetItemTemplate={targetItemTemplate}
          breakpoint="800px"
          filter
          filterBy="label"
          sourceFilterPlaceholder="Search"
          targetFilterPlaceholder="Search"
          sourceStyle={{ height: '30rem' }}
          targetStyle={{ height: '30rem' }}
          showSourceControls={false}
          showTargetControls={false}
          {...(props.serverControlledSearch && {
            sourceFilterValue: props.searchTerm,
            onSourceFilterChange: (e) => handleSourceFilterChange(e),
          })}
        />
      )}
    </>
  );
}

export default PickListSelect;
